import { render, staticRenderFns } from "./DialogoDeSorteioSelecionado.vue?vue&type=template&id=6d1957c9&scoped=true&"
import script from "./DialogoDeSorteioSelecionado.vue?vue&type=script&lang=ts&"
export * from "./DialogoDeSorteioSelecionado.vue?vue&type=script&lang=ts&"
import style0 from "./DialogoDeSorteioSelecionado.vue?vue&type=style&index=0&id=6d1957c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1957c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
